import { FormFieldLabel } from '@alison/ui';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import type { PlatformField } from './networks.types.js';

const LABEL_SX = { color: 'text.disabled', fontSize: 10 };

const UNAVAILABLE_HINT: Record<string, string | undefined> = {
  platform: 'Clear Country to pick a Placement',
  country: 'Clear Placement to pick a Country',
};

export function CampaignField({
  field,
  value,
  busy,
  readOnly = false,
  onSet,
}: {
  field: PlatformField;
  value: string;
  busy: boolean;
  readOnly?: boolean;
  onSet: (next: string) => void;
}): ReactNode {
  if (readOnly) {
    const chosen = field.options.find((option) => option.id === value);
    return (
      <Stack sx={{ gap: 1 }}>
        <FormFieldLabel sx={LABEL_SX}>{field.label.toUpperCase()}</FormFieldLabel>
        <Typography>{chosen?.label ?? (value === '' ? '—' : value)}</Typography>
      </Stack>
    );
  }
  if (field.kind === 'text') {
    return (
      <Stack sx={{ gap: 1 }}>
        <FormFieldLabel sx={LABEL_SX}>{field.label.toUpperCase()}</FormFieldLabel>
        <TextField
          size="small"
          value={value}
          disabled={busy}
          onChange={(event) => onSet(event.target.value)}
          slotProps={{ htmlInput: { 'aria-label': field.label } }}
        />
      </Stack>
    );
  }
  return (
    <Stack sx={{ gap: 1 }}>
      <FormFieldLabel sx={LABEL_SX}>{field.label.toUpperCase()}</FormFieldLabel>
      <TextField
        select
        size="small"
        value={value}
        disabled={field.unavailable || busy}
        helperText={field.blocked ? UNAVAILABLE_HINT[field.key] : undefined}
        onChange={(event) => onSet(event.target.value)}
        slotProps={{ htmlInput: { 'aria-label': field.label } }}
      >
        <MenuItem value="">Select</MenuItem>
        {field.options.map((option) => (
          <MenuItem key={option.id} value={option.id}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
    </Stack>
  );
}
